import { Component } from '@angular/core';
import { SearchableEntityServiceFactory } from '../../../../../shared/services/searchable-entity/searchable-entity-service-factory';
import { NavigationService } from '../../../../../core/navigation.service';
import { SharedServiceRegistry } from '../../../../../shared/shared-service-registry';
import { ReportsConfigurationButtonService } from '../../services/reports-configuration-button.service';
import { ReportsConfigurationActionService } from '../../services/reports-configuration-action.service';
import { ReportsConfigurationBackendService } from '../../services/reports-configuration-backend.service';
import { ReportsConfigurationDataService } from '../../services/reports-configuration-data.service';
import { ReportsConfigurationDataEditorService } from '../../services/reports-configuration-data-editor.service';

@Component({
    selector: 'lfwms-reports-configuration-details',
    templateUrl: './reports-configuration-details.component.html',
    styleUrls: ['./reports-configuration-details.component.css'],
})
export class ReportsConfigurationDetailsComponent {

    public serviceFactory: SearchableEntityServiceFactory;

    constructor(protected dataService: ReportsConfigurationDataService,
            protected navService: NavigationService,
            protected actionService: ReportsConfigurationActionService,
            protected buttonService: ReportsConfigurationButtonService,
            protected dataEditor: ReportsConfigurationDataEditorService,
            protected backendService: ReportsConfigurationBackendService,
            protected sharedServiceRegistry: SharedServiceRegistry) {
        this.serviceFactory = new SearchableEntityServiceFactory(dataService,
            actionService, backendService, dataEditor, buttonService);
    }

}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/reports/reports-configuration/reports-configuration-home/reports-configuration-details/reports-configuration-details.component.ts